import React, { useLayoutEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default function EbuCbuPieChart(props) {
  const { onClick, isHayyak, ebuLabel, cbuLabel, showMnpData = false } = props;

  useLayoutEffect(() => {
    // Chart 1 EBU
    const chart = am4core.create("chartdiv95", am4charts.PieChart);
    chart.hiddenState.properties.opacity = 0;

    chart.data = ebuLabel;

    var pieSeries = chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "litres";
    pieSeries.dataFields.category = "country";
    chart.innerRadius = am4core.percent(40);

    pieSeries.slices.template.fillOpacity = 1;

    pieSeries.slices.template.events.on("hit", function () {
      onClick(showMnpData ? "Hayyak" : "EBU");
    });

    var hs = pieSeries.slices.template.states.getKey("hover");
    hs.properties.scale = 1;
    hs.properties.fillOpacity = 0.5;

    let totalLabel = chart.createChild(am4core.Label);
    const totalEbu = ebuLabel.reduce((sum, item) => sum + item.litres, 0);
    totalLabel.text = showMnpData ? `Hayyak: ${totalEbu}` : "CBU";
    totalLabel.fontSize = 18;
    totalLabel.align = "center";
    totalLabel.isMeasured = false;
    totalLabel.x = am4core.percent(50);
    totalLabel.y = am4core.percent(50);
    totalLabel.horizontalCenter = "middle";
    totalLabel.verticalCenter = "middle";
    totalLabel.cursorOverStyle = am4core.MouseCursorStyle.pointer;
    if (showMnpData) {
      totalLabel.events.on("hit", () => onClick("Hayyak"));
    }

    // Chart 2 CBU
    const chartCbu = am4core.create("chartdiv96", am4charts.PieChart);
    chartCbu.hiddenState.properties.opacity = 0;

    chartCbu.data = cbuLabel;

    var pieSeriesCbu = chartCbu.series.push(new am4charts.PieSeries());
    pieSeriesCbu.dataFields.value = "litres";
    pieSeriesCbu.dataFields.category = "country";
    chartCbu.innerRadius = am4core.percent(40);

    pieSeriesCbu.slices.template.fillOpacity = 1;

    pieSeriesCbu.slices.template.events.on("hit", function () {
      onClick(showMnpData ? "Baqati" : "CBU");
    });

    var hsCbu = pieSeriesCbu.slices.template.states.getKey("hover");
    hsCbu.properties.scale = 1;
    hsCbu.properties.fillOpacity = 0.5;

    let totalLabelCBU = chartCbu.createChild(am4core.Label);
    const totalCbu = cbuLabel.reduce((sum, item) => sum + item.litres, 0);
    totalLabelCBU.text = showMnpData ? `Baqati: ${totalCbu}` : "CBU";
    totalLabelCBU.fontSize = 18;
    totalLabelCBU.align = "center";
    totalLabelCBU.isMeasured = false;
    totalLabelCBU.x = am4core.percent(50);
    totalLabelCBU.y = am4core.percent(50);
    totalLabelCBU.horizontalCenter = "middle";
    totalLabelCBU.verticalCenter = "middle";
    totalLabelCBU.cursorOverStyle = am4core.MouseCursorStyle.pointer;
    if (showMnpData) {
      totalLabelCBU.events.on("hit", () => onClick("Baqati"));
    }

    return () => {
      chart.dispose();
      chartCbu.dispose();
    };
  }, [isHayyak]);

  return (
    <div
      style={{
        width: "100%",
        height: "500px",
        direction: "ltr",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
      }}
    >
      <div
        id="chartdiv95"
        style={{ width: "45%", height: "350px", direction: "ltr" }}
      />
      <div
        id="chartdiv96"
        style={{ width: "45%", height: "350px", direction: "ltr" }}
      />
    </div>
  );
}
